import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import VideoInput from './VideoInput'

export default class Home extends Component {
  state = {
    camera: false,
  };
  camera = () => {
    this.setState({
      camera: true
    })
  }
  cameraOff = () => {
    this.setState({
      camera: false
    })
  }
  render() {
    return (
      <div>
        <div style={{
          backgroundImage: "url('https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/backgrounds%2Fcargorx.gif?alt=media&token=93c41d0a-eef8-4678-990f-7641ac77c938')",
          backgroundSize: "cover", height: "100vh", marginTop: "-20px", backgroundPosition: "center"
        }}>
          <div style={{

            background: "linear-gradient(160deg,rgba(250, 0, 0, .9),rgba(200, 0, 0, .9),rgba(150,0,0,.9),rgba(100,0,0,.9)),url('https://firebasestorage.googleapis.com/v0/b/singularity-ai.appspot.com/o/dotBG.gif?alt=media&token=1dda064d-5efc-4ea1-8377-8173892a4d3a')",

            //backgroundImage: "url('https://firebasestorage.googleapis.com/v0/b/singularity-ai.appspot.com/o/dotBG.gif?alt=media&token=1dda064d-5efc-4ea1-8377-8173892a4d3a')", 
            backgroundSize: "cover", height: "100vh", marginTop: "-20px", opacity: ".9"
          }}>
            <div style={{
              background: "linear-gradient(160deg,rgba(0, 0, 0, .8),rgba(0, 0, 0, .8),rgba(0,0,0,.7),rgba(0,0,0,.7)),url('')",
              backgroundSize: "cover", height: "100vh", marginTop: "20px", opacity: "1"

            }}>

              {/*}
            <h2>BNK48 Facial Recognition App</h2>
            <li>
              <Link to="/photo">Photo Input</Link>
        </li>*/}
              <li>
                  <i
                  onClick={() => this.camera()}                    
                  style={{
                      marginTop: "40vh",
                      marginLeft: "-20px"
                    }}
                    class="material-icons camera">
                    { this.state.camera ? "camera" :
                    "camera_alt" }
                </i>
              </li>
            </div>
          </div>
        </div>
       { this.state.camera ? 
        <div 
        onClick={() => this.cameraOff()}                    
        style={{
          width: "1000px",
          backgroundColor: "",
          margin: "0 auto",
          position: "fixed",
          top: "50%",
          left: "50%",
          /* bring your own prefixes */
          transform: "translate(-50%, -50%)"
        }}>
          <VideoInput />
        </div> : null}
      </div>
    );
  }
}
